(ns common.resource.adserver-account
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]))

(def collection-url (:api/agency-adserver-accounts url-tpl/templates))
(def instance-url (:api/agency-adserver-account url-tpl/templates))
(def adform-oauth-url (:api/agency-adserver-account-adform-oauth url-tpl/templates))
(def adform-verify-url (:api/agency-adserver-account-adform-verify url-tpl/templates))
(def adform-forget-url (:api/agency-adserver-account-adform-forget url-tpl/templates))
(def dcm-oauth-url (:api/agency-adserver-account-dcm-oauth url-tpl/templates))
(def dcm-verify-url (:api/agency-adserver-account-dcm-verify url-tpl/templates))
(def dcm-forget-url (:api/agency-adserver-account-dcm-forget url-tpl/templates))
(def dcm-userprofile-url (:api/agency-adserver-account-dcm-userprofile url-tpl/templates))

;; Get adserver-account by id
(rf/reg-event-fx :resource.adserver-account/get-one
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ adserver-account-id]]
    {:db (assoc db :resource.adserver-account/one {:state :pending})
     :http
     {:method :get
      :uri (url-tpl/render instance-url (assoc url-context :adserver-account-id adserver-account-id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/get-one-success]
      :on-failure [:resource.adserver-account/get-one-failure]}}))

(rf/reg-event-db :resource.adserver-account/get-one-success
  (fn [db [_ adserver]]
    (assoc db :resource.adserver-account/one {:state :success
                                              :value adserver})))

(rf/reg-event-db :resource.adserver-account/get-one-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/one {:state :failure
                                              :value []})))

;; Post adserver-account
(rf/reg-event-fx :resource.adserver-account/create
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    {:db (assoc db :resource.adserver-account/create {:state :pending})
     :http
     {:method :post
      :params payload
      :uri (url-tpl/render collection-url url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/create-success]
      :on-failure [:resource.adserver-account/create-failure]}}))

(rf/reg-event-db :resource.adserver-account/create-success
  (fn [db _]
    (assoc db :resource.adserver-account/create {:state :success})))

(rf/reg-event-db :resource.adserver-account/create-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/create {:state :failure})))

;; Patch adserver-account
(rf/reg-event-fx :resource.adserver-account/patch
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    (let [params (dissoc payload :id)]
      {:db (assoc db :resource.adserver-account/patch {:state :pending})
       :http
       {:method :patch
        :params params
        :uri (url-tpl/render instance-url (assoc url-context :adserver-account-id (:id payload)))
        :headers {"Authorization" (:resource.user/token cofx)}
        :on-success [:resource.adserver-account/patch-success]
        :on-failure [:resource.adserver-account/patch-failure]}})))

(rf/reg-event-db :resource.adserver-account/patch-success
  (fn [db _]
    (assoc db :resource.adserver-account/patch {:state :success})))

(rf/reg-event-db :resource.adserver-account/patch-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/patch {:state :failure})))

;; Delete adserver-account
(rf/reg-event-fx :resource.adserver-account/delete
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/delete {:state :pending})
     :http
     {:method :delete
      :uri (url-tpl/render instance-url (assoc url-context :adserver-account-id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/delete-success]
      :on-failure [:resource.adserver-account/delete-failure]}}))

(rf/reg-event-db :resource.adserver-account/delete-success
  (fn [db _]
    (assoc db :resource.adserver-account/delete {:state :success})))

(rf/reg-event-db :resource.adserver-account/delete-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/delete {:state :failure})))

(rf/reg-event-fx :resource.adserver-account/adform-verify
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/adform-verify {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render adform-verify-url (assoc url-context :adserver-account-id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/adform-verify-success]
      :on-failure [:resource.adserver-account/adform-verify-failure]}}))

(rf/reg-event-db :resource.adserver-account/adform-verify-success
  [(rf/path :resource.adserver-account/adform-verify)]
  (fn [_ [_ user-info]]
    {:state :success
     :value user-info}))

(rf/reg-event-db :resource.adserver-account/adform-verify-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/adform-verify {:state :failure})))

(rf/reg-event-fx :resource.adserver-account/adform-forget
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/adform-forget {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render adform-forget-url (assoc url-context :adserver-account-id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/adform-forget-success]
      :on-failure [:resource.adserver-account/adform-forget-failure]}}))

(rf/reg-event-db :resource.adserver-account/adform-forget-success
  (fn [db]
    (assoc db :resource.adserver-account/adform-forget {:state :success})))

(rf/reg-event-db :resource.adserver-account/adform-forget-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/adform-forget {:state :failure})))

(rf/reg-event-fx :resource.adserver-account/adform-oauth
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/adform-oauth {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render adform-oauth-url (assoc url-context :adserver-account-id id))
      :params {:url (str js/window.location.origin
                         (r.easy/href :agency/configuration url-context {:adserver-account-id id}))}
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/adform-oauth-success]
      :on-failure [:resource.adserver-account/adform-oauth-failure]}}))

(rf/reg-event-db :resource.adserver-account/adform-oauth-success
  (fn [db _]
    (assoc db :resource.adserver-account/adform-oauth {:state :success})))

(rf/reg-event-db :resource.adserver-account/adform-oauth-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/adform-oauth {:state :failure})))

(rf/reg-event-fx :resource.adserver-account/dcm-verify
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/dcm-verify {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render dcm-verify-url (assoc url-context :adserver-account-id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/dcm-verify-success]
      :on-failure [:resource.adserver-account/dcm-verify-failure]}}))

(rf/reg-event-db :resource.adserver-account/dcm-verify-success
  [(rf/path :resource.adserver-account/dcm-verify)]
  (fn [_ [_ user-info]]
    {:state :success
     :value user-info}))

(rf/reg-event-db :resource.adserver-account/dcm-verify-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/dcm-verify {:state :failure})))

(rf/reg-event-fx :resource.adserver-account/dcm-forget
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/dcm-forget {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render dcm-forget-url (assoc url-context :adserver-account-id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/dcm-forget-success]
      :on-failure [:resource.adserver-account/dcm-forget-failure]}}))

(rf/reg-event-db :resource.adserver-account/dcm-forget-success
  (fn [db]
    (assoc db :resource.adserver-account/dcm-forget {:state :success})))

(rf/reg-event-db :resource.adserver-account/dcm-forget-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/dcm-forget {:state :failure})))

(rf/reg-event-fx :resource.adserver-account/dcm-oauth
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account/dcm-oauth {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render dcm-oauth-url (assoc url-context :adserver-account-id id))
      :params {:url (str js/window.location.origin
                         (r.easy/href :agency/configuration url-context {:adserver-account-id id}))}
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/dcm-oauth-success]
      :on-failure [:resource.adserver-account/dcm-oauth-failure]}}))

(rf/reg-event-db :resource.adserver-account/dcm-oauth-success
  (fn [db _]
    (assoc db :resource.adserver-account/dcm-oauth {:state :success})))

(rf/reg-event-db :resource.adserver-account/dcm-oauth-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/dcm-oauth {:state :failure})))

;; Post adserver-account profile-id
(rf/reg-event-fx :resource.adserver-account/userprofile
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload id]]
    {:db (assoc db :resource.adserver-account/userprofile {:state :pending})
     :http
     {:method :post
      :params payload
      :uri (url-tpl/render dcm-userprofile-url (assoc url-context :adserver-account-id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account/userprofile-success]
      :on-failure [:resource.adserver-account/userprofile-failure]}}))

(rf/reg-event-db :resource.adserver-account/userprofile-success
  (fn [db _]
    (assoc db :resource.adserver-account/userprofile {:state :success})))

(rf/reg-event-db :resource.adserver-account/userprofile-failure
  (fn [db [_ _]]
    (assoc db :resource.adserver-account/userprofile {:state :failure})))
